module.exports = __webpack_public_path__ + "static/media/navCta.8bc17038.png";